import { useContext, useEffect, useState } from "react"
import VisibilityContext from "src/provider/state-manager/visibilityProvider"
import ApiContext from "src/provider/API/call-service"
import UserContext from "src/provider/state-manager/userProvider"
import { AppSpan, AppText, Button, CustomContainer, FlexRow, Form, FormGroup, FormGroupWithIcon, GridContainer } from "src/style"
import { FiChevronDown } from "react-icons/fi"
import {ImNotification} from 'react-icons/im'
import { AppCenterPopupD3, CenterPopupHeaderD3, TxPinVerification, TxPinVerificationD3 } from "src/component"
import { moneyFormat } from "src/utils/utility"

export const FundsLiquidationD3: React.FC<any> = ({data, type, getUpdatedInvestments, back, close}) => {
    const {API} = useContext(ApiContext)
    const {user: {accountWithBalanceDetails}} = useContext(UserContext)
    const [input, setInput] = useState({
        sourceAccount: '', amount: '', liquidationType: '', narration: '',
        fixedDepositAccountNumber: data?.accountNumber, pin: ''
    })
    const [view, setView] = useState('liquidate-fund')

    useEffect(() => {
        if (accountWithBalanceDetails?.length === 1) {
            setInput({...input, sourceAccount: accountWithBalanceDetails[0].nuban})
        }
    }, [accountWithBalanceDetails])

    const handleInput = (e: React.ChangeEvent<HTMLInputElement|HTMLTextAreaElement|HTMLSelectElement>) => {
        if (e.target.name === 'amount') {
            let val = e.target.value.replace(/,/g, '')
            if (!isNaN(Number(val))) {
                setInput({...input, amount: val})
            }
        }
        else setInput({...input, [e.target.name]: e.target.value})
    }

    async function handleProceed(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()
        setView('pin')
    }

    async function handleSubmit() {
        const payload: any = {...input}
        if (!input.amount) payload.amount = 0
        const response = await API.liquidateFixedDeposit(payload)
        if (response) {
            getUpdatedInvestments()
            close()
        }
    }

    return (
        <>
            { view === 'liquidate-fund' &&
                <AppCenterPopupD3 height={input.liquidationType === '1' ? '43' : '33'} zIndex='6' overflow='hidden' close={close}>
                    <CenterPopupHeaderD3 title='Liquidate Funds' close={back} />
                    <CustomContainer 
                        height={input.liquidationType === '1' ? '43' : '33'}
                        style={{maxHeight: '81%'}}
                        className="popup-content-container"
                    >
                        <GridContainer
                            bgColor="#E7F6F5" minHeight="6.2" padding="1"
                            leftPadding="2" rightPadding="2" radius="0.8"
                        >
                            <FlexRow>
                                <ImNotification style={{color: '#0D968F', fontSize: '1.8rem'}} />
                                <AppText textSize="1.2" color="#0A756F" leftMargin="1">
                                    There will be a penalty of <AppSpan textSize="1.2" color="#0A756F" fontWeight="600">12%</AppSpan>
                                </AppText>
                            </FlexRow>
                        </GridContainer>
                        <Form onSubmit={handleProceed} topMargin='2'>
                            <FormGroupWithIcon>
                                <label>Liquidation Type</label>
                                <div className="input-with-icon">
                                    <select 
                                        name='liquidationType'
                                        value={input.liquidationType}
                                        style={{color: input.liquidationType ? '#000000' : '#667085'}}
                                        onChange={handleInput}
                                        required
                                    >
                                        <option value="">Select Liquidation Type</option>
                                        <option value="1">Part Liquidation</option>
                                        <option value="0">Full Liquidation</option>
                                    </select>
                                    <FiChevronDown className="input-with-icon-tag" />
                                </div>
                            </FormGroupWithIcon>
                            { input.liquidationType === '1' &&
                                <FormGroup>
                                    <label>Amount</label>
                                    <input 
                                        placeholder='Enter Amount' 
                                        name='amount'
                                        value={input.amount ? moneyFormat(input.amount) : ''}
                                        onChange={handleInput}
                                        autoComplete="off"
                                        required
                                    />
                                </FormGroup>
                            }
                           
                            <CustomContainer topMargin='2.5'>
                                <Button 
                                    width='100' sizeUnit="%" height='4' 
                                    borderColor='#0D968F' hoverBgColor='#fff' 
                                    hoverColor='#0D968F' titleSize='1.4'
                                >
                                    Liquidate
                                </Button>
                            </CustomContainer>
                        </Form>
                    </CustomContainer>
                </AppCenterPopupD3>
            }
            { view === 'pin' &&
                <TxPinVerificationD3
                    close={close}
                    onPinChange={(pin: string) => setInput({...input, pin})}
                    next={handleSubmit} 
                />
            }
        </>
    )
}